import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { selectLastCheckedDocument, useAppSelector } from '@ibk/shared-config';
import { getCookie, sessionStorageService, setCookie, StorageKeys } from '@ibk/shared-utils';
import { VoucherContractRechargeType } from '../types';
import { useHappyHolidaysEndOfTheYearRecharge } from './useHappyHolidaysEndOfTheYearRecharge';
const DONT_HAVE_INTEREST_COOKIE_KEY = 'happyHolidaysEndOfTheYearRechargeModalDontHaveInterest';
export function useHappyHolidaysEndOfTheYearRechargeModal() {
    const navigate = useNavigate();
    const userCpf = useAppSelector(selectLastCheckedDocument) ?? '';
    const { isInPeriod, isTermAccepted } = useHappyHolidaysEndOfTheYearRecharge();
    const [dontHaveInterestCookieKey, setDontHaveInterestCookieKey] = useState('');
    const [isModalCanBeOpened, setIsModalCanBeOpened] = useState(false);
    useEffect(() => {
        if (userCpf) {
            setDontHaveInterestCookieKey(`${DONT_HAVE_INTEREST_COOKIE_KEY}_${userCpf}`);
        }
    }, [userCpf]);
    useEffect(() => {
        if (isInPeriod && !isTermAccepted && dontHaveInterestCookieKey) {
            const alreadySeen = sessionStorageService.getItemSync(StorageKeys.HappyHolidaysEndOfTheYearRechargeModalAlreadySeen) ??
                false;
            const dontHaveInterest = getCookie(dontHaveInterestCookieKey) === 'true';
            setIsModalCanBeOpened(!alreadySeen && !dontHaveInterest);
        }
        else {
            setIsModalCanBeOpened(false);
        }
    }, [isInPeriod, isTermAccepted, dontHaveInterestCookieKey]);
    const onGoToRecharge = useCallback(() => {
        navigate('/beneficios/nova-recarga', {
            state: { rechargeType: VoucherContractRechargeType.HAPPY_HOLIDAYS_END_OF_THE_YEAR },
        });
    }, [navigate]);
    const onRememberLater = useCallback(() => {
        sessionStorageService.setItemSync(StorageKeys.HappyHolidaysEndOfTheYearRechargeModalAlreadySeen, true);
    }, []);
    const onDontHaveInterest = useCallback(() => {
        setCookie(dontHaveInterestCookieKey, 'true');
    }, [dontHaveInterestCookieKey]);
    return {
        isModalCanBeOpened,
        onGoToRecharge,
        onRememberLater,
        onDontHaveInterest,
    };
}
